import { defineMessages } from 'react-intl';

export const partnerActivationMessages = defineMessages({
    'partner_activation.invalid_heading': {
        id: 'partner_activation.invalid_heading',
        defaultMessage: 'Something went wrong.',
        description:
            'Header for the error shown when a partner member activation link cannot be read.',
    },
    'partner_activation.invalid_description': {
        id: 'partner_activation.invalid_description',
        defaultMessage:
            "This link isn't valid. Please go back to the app you came from and try again.",
        description:
            'Explanation of the error shown when a partner member activation link cannot be read.',
    },
    'partner_activation.expired_heading': {
        id: 'partner_activation.expired_heading',
        defaultMessage: 'This link has expired.',
        description:
            'Header for the error shown when a partner member activation link is expired.',
    },
    'partner_activation.expired_description': {
        id: 'partner_activation.expired_description',
        defaultMessage:
            'Go back to the app you came from and open Calm Health again.',
        description:
            'Explanation of the error shown when a partner member activation link is expired.',
    },
    'partner_activation.retry_heading': {
        id: 'partner_activation.retry_heading',
        defaultMessage: 'Something went wrong.',
        description:
            'Header for the error shown when submitting a partner member activation fails and can be retried.',
    },
    'partner_activation.retry_description': {
        id: 'partner_activation.retry_description',
        defaultMessage: 'Please try again.',
        description:
            'Explanation of the error shown when submitting a partner member activation fails and can be retried.',
    },
    'partner_activation.try_again': {
        id: 'partner_activation.try_again',
        defaultMessage: 'Try again',
        description:
            'Button text on the partner member activation error that restarts the activation.',
    },
    'partner_activation.go_to_calm_health': {
        id: 'partner_activation.go_to_calm_health',
        defaultMessage: 'Go to Calm Health',
        description:
            'Button text on the partner member activation error that takes the member into Calm Health.',
    },
});
